import { motion } from "framer-motion";
import {
    LineChart,
    Crosshair,
    GitCompareArrows,
    ArrowLeftRight,
    ShieldCheck,
    Zap,
    Timer,
} from "lucide-react";

const BENEFITS = [
    {
        icon: LineChart,
        title: "Support & Resistance",
        text: "Mengenal pasti kawasan Support & Resistance dengan tepat.",
        tag: "AUTO ZONE",
    },
    {
        icon: Crosshair,
        title: "Sharp Entry",
        text: "Membantu mencari entry yang lebih tepat berbanding entry secara rawak.",
        tag: "PRECISION",
    },
    {
        icon: GitCompareArrows,
        title: "Fibonacci Auto",
        text: "Zone retracement Fibonacci diberikan secara automatik — tak perlu lukis manual.",
        tag: "NO MANUAL",
    },
    {
        icon: ArrowLeftRight,
        title: "Buy & Sell Zone",
        text: "Memudahkan trader mengenal pasti kawasan Buy Zone dan Sell Zone.",
        tag: "SIGNAL",
    },
    {
        icon: ShieldCheck,
        title: "Anti FOMO",
        text: "Entry berkualiti dan mengurangkan FOMO secara drastik.",
        tag: "MINDSET",
    },
    {
        icon: Zap,
        title: "Semua Style",
        text: "Sesuai digunakan untuk scalping, intraday dan swing trading.",
        tag: "FLEXIBLE",
    },
    {
        icon: Timer,
        title: "Jimat Masa",
        text: "Menjimatkan masa sebab semua zone penting dah ada secara auto.",
        tag: "1 CLICK",
    },
];

export default function Benefits() {
    return (
        <section
            id="benefits"
            data-testid="benefits-section"
            className="relative bg-[#FAF9F6] text-[#060614] overflow-hidden"
        >
            <div className="mx-auto max-w-7xl px-5 md:px-10 pt-24 md:pt-32">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                    <h2 className="font-display uppercase text-[12vw] sm:text-[9vw] md:text-[6.5vw] leading-[0.9] text-center md:text-left">
                        BENEFIT{" "}
                        <span style={{ color: "#0044FE" }}>SUPER</span>
                        <span style={{ color: "#ED1C24" }}>ZONE</span>.
                    </h2>
                    <div className="font-mono-tight text-xs uppercase tracking-widest text-black/60 md:pb-4 text-center md:text-right">
                        07 alasan &nbsp;/&nbsp; 0 tekaan
                    </div>
                </div>

                <div className="mt-10 h-px w-full bg-black/15" />
            </div>

            {/* Smart card grid */}
            <div className="mx-auto max-w-7xl px-5 md:px-10 pb-24 md:pb-32 mt-10">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                    {BENEFITS.map((b, i) => {
                        const Icon = b.icon;
                        // Feature the first card (span 2 cols on lg)
                        const featured = i === 0;
                        return (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{
                                    duration: 0.6,
                                    delay: i * 0.05,
                                    ease: [0.2, 0.8, 0.2, 1],
                                }}
                                className={`group relative border-2 border-black/90 bg-white overflow-hidden hover:-translate-y-1 transition-transform duration-500 ${
                                    featured ? "lg:col-span-2 lg:row-span-2" : ""
                                }`}
                                data-testid={`benefit-item-${i}`}
                                style={{ boxShadow: "6px 6px 0 #060614" }}
                            >
                                {/* Header bar */}
                                <div className="flex items-center justify-between px-4 py-2 border-b-2 border-black/90 bg-[#0044FE] text-[#FAF9F6]">
                                    <span className="font-mono-tight text-[10px] tracking-[0.22em] uppercase">
                                        {String(i + 1).padStart(2, "0")} · {b.tag}
                                    </span>
                                    <span className="h-2 w-2 rounded-full bg-[#ED1C24] blink" />
                                </div>

                                <div className={`p-5 md:p-6 ${featured ? "md:p-10" : ""}`}>
                                    <div className="flex items-center gap-3 mb-4">
                                        <span
                                            className={`inline-flex items-center justify-center border-2 border-black/90 bg-[#ED1C24] text-[#FAF9F6] ${
                                                featured
                                                    ? "w-14 h-14 md:w-16 md:h-16"
                                                    : "w-11 h-11"
                                            }`}
                                            style={{ boxShadow: "3px 3px 0 #060614" }}
                                        >
                                            <Icon
                                                className={featured ? "w-7 h-7 md:w-8 md:h-8" : "w-5 h-5"}
                                                strokeWidth={2.5}
                                            />
                                        </span>
                                        <div
                                            className={`font-display uppercase leading-tight ${
                                                featured ? "text-3xl md:text-5xl" : "text-xl md:text-2xl"
                                            }`}
                                        >
                                            {b.title}
                                        </div>
                                    </div>
                                    <p
                                        className={`text-black/75 leading-relaxed ${
                                            featured ? "text-base md:text-lg" : "text-sm md:text-base"
                                        }`}
                                    >
                                        {b.text}
                                    </p>
                                </div>

                                {/* Corner accent */}
                                <span className="absolute top-0 right-0 w-6 h-6 bg-[#ED1C24] transition-all duration-500 group-hover:w-10 group-hover:h-10" />
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
